//import axios from "axios";

const logger = {
  async info(message) {
	console.log(message);
    // try {
    //   await axios.post("http://localhost:2000/logApi/log", {
    //     level: "info",
    //     message
    //   });
    // } catch (err) {
    //   console.error("Frontend log failed:", err);
    // }
  },

  async error(message) {
	console.log(message);
    // try {
    //   await axios.post("http://localhost:2000/logApi/log", {
    //     level: "error",
    //     message
    //   });
    // } catch (err) {
    //   console.error("Frontend log failed:", err);
    // }
  }
};

export default logger;
